export default __webpack_public_path__ + "locales/ko-KR/Article.json?hash=911f917e2421375ed62b3b018f1b5c85";